export enum FitLevel {
	GOOD_MATCH = 'Good Match',
	POTENTIAL_MATCH = 'Potential Match',
	BETTER_OPTIONS_AVAILABLE = 'Better Options Available'
}
